import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=dc9f18b4&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=dc9f18b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9f18b4",
  null
  
)

export default component.exports